import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Lock, Globe, Check, Zap, Sparkles } from 'lucide-react';
const comboIncludes = ['Todo lo del Mega Pack 360 (6 tomos + 4 bonos)', 'Metodologías por disciplina: Salud, Ciencias Naturales, Sociales y Educación', 'Enfoques cuantitativo, cualitativo y mixto explicados', 'Guía de los diseños de investigación más utilizados'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-black relative" data-id="element-192">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-gold/20 blur-[120px] rounded-full pointer-events-none" data-id="element-193"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-194">
        <div className="text-center mb-10" data-id="element-195">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3" data-id="element-196">
            Elige tu pack
          </h2>
          <p className="text-gold-light text-sm md:text-base" data-id="element-197">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        {/* OFERTA 1: MEGA PACK SOLO */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-card border border-gold/60 rounded-3xl p-1 relative shadow-[0_0_30px_rgba(212,175,55,0.1)] mb-8" data-id="element-198">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold/90 text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs" data-id="element-199">
            🏆 Oferta principal
          </div>

          <div className="bg-black rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-200">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-201">
              Mega Pack Metodología de la Investigación 360
            </h3>
            <p className="text-base text-gray-300 mb-6" data-id="element-202">
              Los 6 tomos + 4 bonos estratégicos listos para usar en el aula.
            </p>

            <div className="mb-6" data-id="element-203">
              <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-204">
                USD 45,00
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-205">
                <span className="text-2xl md:text-3xl text-white" data-id="element-206">Hoy:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold" data-id="element-207">
                  USD 19,90
                </span>
              </div>
            </div>

            <Button href="https://www.ebookemprende.shop/cart/48599651778792:1" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Mega Pack Metodología de la Investigación 360',
                value: 19.9,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-208">
              🟡 QUIERO EL MEGA PACK
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400" data-id="element-209">
              <span className="flex items-center gap-1.5" data-id="element-210">
                <Lock size={12} className="text-gold" data-id="element-211" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-212">
                <Zap size={12} className="text-gold" data-id="element-213" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-214">
                <Shield size={12} className="text-gold" data-id="element-215" /> Garantía 7 días
              </span>
            </div>
          </div>
        </motion.div>

        {/* OFERTA 2: MEGA PACK + DISCIPLINAS */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-dark-card border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(212,175,55,0.2)]" data-id="element-216">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-217">
            <Sparkles size={14} data-id="element-218" /> Más elegido · Mejor valor
          </div>

          <div className="bg-black rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-219">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-220">
              Mega Pack Metodología de la Investigación 360 + Metodología por
              Disciplina
            </h3>
            <p className="text-base text-gray-300 mb-6" data-id="element-221">
              Llevas el pack completo más el material que explica cómo se
              investiga en cada área de conocimiento.
            </p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-gold/5 border border-gold/20 rounded-xl p-4" data-id="element-222">
              {comboIncludes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-223">
                  <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-224" />
                  <span data-id="element-225">{item}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-226">
              <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-227">
                USD 72,90
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-228">
                <span className="text-2xl md:text-3xl text-white" data-id="element-229">Hoy:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold" data-id="element-230">
                  USD 27,90
                </span>
              </div>
            </div>

            <Button href="https://www.ebookemprende.shop/cart/48603374223592:1" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Mega Pack 360 + Metodología por Disciplina',
                value: 27.9,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-231">
              🟡 LLEVAR PACK COMPLETO
            </Button>

            <div className="bg-white/5 border border-white/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-232">
              <Globe className="text-gold shrink-0 mt-0.5" size={14} data-id="element-233" />
              <p className="text-[11px] text-gray-400 leading-snug" data-id="element-234">
                Pagas en tu moneda local. El importe se adapta automáticamente
                al país desde donde compras.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}